import { Outlet } from 'react-router-dom'
import ProviderServicesEvent from './context/servicesContext'
import ContainerEventsBatismo from './CrudEventos/components/container'

export type IEvento = {
  id: number,
  descricao: string,
  atividade: number,
  inicio: string,
  fim: string,
  nome_cidade: string,
  nome_sede: string,
  sede: number,
  cidade: number,
  inscricao: boolean,
  ativo: boolean,
  celula: number | string,
  cep: string,
  whatsapp: string
}

export default function Eventos() {

  return (
    <>
      <ProviderServicesEvent>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerEventsBatismo />
        </div>
      </ProviderServicesEvent>
      <Outlet />
    </>
  )
}
